import React from 'react';
import classNames from 'classnames';

export default function Notification(props: {
    children?: React.ReactNode,
    type?: string
}) {
    let {
        children,
        type = ''
    } = props;

    const classes = classNames('notification', {
        [`is-${type}`]: type.length
    });

    return (
        <div className={classes}>
            {children}
        </div>
    );
}
